<template>
    <div class="card multisteps-form__panel p-3 border-radius-xl bg-white" data-animation="FadeIn">
        <div :class="{ 'blur-effect': loadingUfs }">
            <h5 class="font-weight-bolder mb-0">Dados cadastrais</h5>
            <p class="mb-0 text-sm">Você pode altera-los abaixo</p>
            <small>(*) Campos obrigatórios</small>
            <div class="mt-2 row">
                <div class="col-6">
                    <argon-button @click.prevent="openModalChangePassword" color="primary" class="ms-auto mb-0 js-btn-next btn custom-btn bg-segment-primary-color">Alterar Senha</argon-button>
                </div>
            </div>
        </div>
        
        <div v-if="loadingUfs" class="waiting-message segment-primary-color">
            <span>
                Aguarde <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </span>
        </div>
        <div class="multisteps-form__content" :class="{ 'blur-effect': loadingUfs }">
            <form role="form" class="text-start" @submit.prevent="formValidation">
                <div class="row mt-3">
                    <div class="col-12 col-sm-12 mt-3 mt-sm-0">
                        <label>Nome*</label>
                        <argon-input id="name" v-model="form.name" class="multisteps-form__input" type="text"
                            placeholder="Nome" :error="validate.name.$error" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-sm-6 mt-3 mt-sm-0">
                        <label>Email*</label>
                        <argon-input id="email" v-model="form.email" class="multisteps-form__input" type="email"
                            placeholder="email@mail.com" :error="validate.email.$error" />
                    </div>
                    <div class="col-6 col-sm-6 mt-3 mt-sm-0">
                        <label>Telefone*</label>
                        <argon-input id="phone" v-model="form.phone" v-maska="maska.phone"
                            class="multisteps-form__input" type="text" placeholder="Telefone"
                            :error="validate.phone.$error" />
                        <!-- <argon-input id="phone" class="multisteps-form__input" type="text" placeholder="Telefone"
                            v-maska="['(##) ####-####', '(##) # ####-####', '## ### #### #### ###']" v-model="form.phone"
                            :error="validate.phone.$error" /> -->
                    </div>
                </div>
                <div v-if="validateCPFOrCNPJ()" class="row">
                    <div class="col-6 col-sm-6 mt-3 mt-sm-0">
                        <label>Estado Civil*</label>
                        <select id="choices-marital-status" v-model="form.marital_status"
                            class="multisteps-form__select form-control" name="choices-marital-status"
                            :error="validate.marital_status.$error">
                            <option value="C">Casado(a)</option>
                            <option value="D">Divorciado(a)</option>
                            <option value="J">Separado(a) Judicialmente</option>
                            <option value="S">Solteiro(a)</option>
                            <option value="A">União Estável</option>
                            <option value="V">Viúvo(a)</option>
                        </select>
                    </div>
                    <div class="col-6 col-sm-6 mt-3 mt-sm-0">
                        <label>Sexo*</label>
                        <select id="choices-gender" v-model="form.gender" class="multisteps-form__select form-control"
                            name="choices-gender" :error="validate.gender.$error">
                            <option value="M">Masculino</option>
                            <option value="F">Feminino</option>
                        </select>
                    </div>
                </div>
                <div class="mt-3 row">
                    <div class="col-12 col-sm-5 mt-3 mt-sm-0">
                        <label>Endereço*</label>
                        <argon-input id="phone" v-model="form.address" class="multisteps-form__input" type="text"
                            placeholder="Endereço" :error="validate.address.$error" />
                    </div>
                    <div class="col-9 col-sm-5 mt-3 mt-sm-0">
                        <label>Complemento*</label>
                        <argon-input id="phone" v-model="form.address_detail" class="multisteps-form__input" type="text"
                            placeholder="Complemento" :error="validate.address_detail.$error" />
                    </div>
                    <div class="col-3 col-lg-2 mt-3 mt-sm-0">
                        <label>Nº</label>
                        <argon-input id="phone" v-model="form.number" class="multisteps-form__input" type="number"
                            placeholder="Nº" :error="validate.number.$error" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-sm-6 mt-3 mt-sm-0">
                        <label>Bairro*</label>
                        <argon-input id="phone" v-model="form.neighborhood" class="multisteps-form__input" type="text"
                            placeholder="Bairro" :error="validate.neighborhood.$error" />
                    </div>
                    <div class="col-6 col-sm-6 mt-3 mt-sm-0">
                        <label>CEP*</label>
                        <argon-input id="cep" v-model="form.postal_code" v-maska="maska.postal_code"
                            class="multisteps-form__input" type="text" placeholder="CEP"
                            :error="validate.postal_code.$error" />
                    </div>
                </div>
                <!-- endereço -->
                <div class="row">
                    <div class="col-4 col-lg-3 mt-3 mt-sm-0">
                        <label>Estado* <i v-if="loadingUfs" class="fa fa-spinner fa-pulse fa-fw"></i></label>
                        <select id="choices-state" v-model="form.state" class="multisteps-form__select form-control"
                            name="choices-state" :disabled="loadingUfs" :error="validate.state.$error">
                            <option v-for="state in states" :key="state" :value="state">{{ state }}</option>

                        </select>
                    </div>
                    <div class="col-8 col-lg-9 mt-3 mt-sm-0">
                        <label>Município* <i v-if="loadingCities" class="fa fa-spinner fa-pulse fa-fw"></i></label>
                        <select id="choices-cities" v-model="form.city" class="multisteps-form__select form-control"
                            name="choices-cities" :disabled="loadingCities" :error="validate.city.$error">
                            <option v-for="city in cities" :key="city" :value="city.nome_cidade">{{ city.nome_cidade }}
                            </option>

                        </select>
                    </div>
                </div>
                <div class="my-auto form-check mt-2 mb-4">
                    <input id="accept_term" v-model="form.accept_term" class="form-check-input" type="checkbox"
                        :error="validate.accept_term.$error" required />
                    <small>
                        Declaro estar acordo com o termo de responsablidade e veracidade dos dados
                    </small>
                </div>
                <div class="button-row d-flex mt-4">
                    <argon-button color="primary" full-width
                        class="ms-auto mb-0 js-btn-next btn custom-btn bg-segment-primary-color"
                        :disabled="!form.accept_term || loading">Salvar <i v-if="loading"
                            class="fa fa-spinner fa-pulse fa-fw"></i></argon-button>
                </div>
            </form>
            <ConfirmDialog group="templating">
                <template #message="slotProps">
                    <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                        <i :class="slotProps.message.icon" class="text-5xl text-primary-500"></i>
                        <p>Declaro estar ciente e concordar que sou o único responsável pela veracidade, atualização e
                            precisão dos <br>
                            dados cadastrais fornecidos à empresa.
                            Reconheço que, em caso de não comunicar à empresa
                            qualquer alteração <br>
                            ou atualização desses dados, não poderei alegar o desconhecimento ou não recebimento de
                            informações.</p>
                    </div>
                </template>
            </ConfirmDialog>
            <Dialog v-model:visible="visible" modal header="Alterar Senha" :style="{ width: '25rem' }">
                <div class="row">
                    <label>Nova Senha</label>
                    <argon-input type="text" placeholder="" v-model="pass.password" />
                </div>
                <div class="row">
                    <label>Confirmar Senha</label>
                    <argon-input type="text" placeholder="" v-model="pass.password_confirmation" />
                </div>
                <div class="mt-4 d-flex justify-content-center">
                    <button :disabled="loadingButton" type="button" @click="changePassword()"
                        class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                        Salvar <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
                    </button>
                </div>
            </Dialog>
        </div>
    </div>
</template>

<script setup>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Dialog from 'primevue/dialog';
import Choices from "choices.js";
import ConfirmDialog from 'primevue/confirmdialog';
import axios from 'axios';
import { onMounted, ref, reactive, computed } from "vue";
import { useConfirm } from "primevue/useconfirm";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showToast } from "@/assets/js/toast.js";
import { SALESFORCE_DIVISIONS } from '@/assets/js/constants.js';
import { useStore } from "vuex";

const store = useStore();
const confirm = useConfirm();
const contractData = computed(() => store.getters.getCurrentContract);
const loading = ref(false);
const loadingUfs = ref(true);
const loadingCities = ref(true);
const loadingButton = ref(false);
const visible = ref(false);
const states = ref();
const cities = ref();
const allCities = ref();
const maska = reactive({
    phone: ref(''),
    postal_code: ref('')
})
const pass = reactive({
    password: ref(''),
    password_confirmation: ref('')
})

const cpfCnpj = store.getters.getCurrentUser.documento

const form = reactive({
    name: ref(''),
    email: ref(''),
    phone: ref(''),
    marital_status: ref(''),
    gender: ref(''),
    state: ref(''),
    city: ref(''),
    municipality_code: ref(''),
    address: ref(''),
    address_detail: ref(''), //complemento
    number: ref(''),
    neighborhood: ref(''),
    postal_code: ref(''),
    accept_term: ref(false),

    // dados para criação da ocorrencia no sf
    division_id: ref(SALESFORCE_DIVISIONS.JURIDICO),
    contract_id: ref(parseInt(contractData.value.contrato_id)),
    origin_id: ref(2)
});

const rules = {
    name: { required },
    email: { required },
    phone: { required },
    marital_status: { required },
    gender: { required },
    state: { required },
    city: { required },
    municipality_code: { required },
    address: { required },
    address_detail: { required },
    number: { required },
    neighborhood: { required },
    postal_code: { required },
    accept_term: { required }
};

const openModalChangePassword = () => {
    visible.value = true
}

const validate = useVuelidate(rules, form);

const formValidation = () => {
    validate.value.$touch();
    if (validate.value.$invalid) {
        showToast('Campos obrigatórios não preenchidos.', 'error');
        return;
    }
    confirm1()
};

const confirm1 = () => {
    confirm.require({
        group: 'templating',
        message: 'Are you sure you want to proceed?',
        header: 'Termo de Responsabilidade',
        icon: 'pi pi-exclamation-triangle',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'Cancelar',
        acceptLabel: 'Aceitar e Salvar',
        accept: () => {
            saveData()
        }
    });
};

const saveData = async () => {

    try {
        loading.value = true

        let cityName = allCities.value.find(cidade => cidade.nome_cidade == form.city && cidade.uf_sigla == form.state);
        form.city = cityName.nome_cidade
        form.municipality_code = parseInt(cityName.id)

        const response = await axios.post('/contact/update-user-data', form);
        if (response.data) {
            showToast('Atualização cadastral solicitada com sucesso.', 'success');
        }
    } catch (error) {
        showToast('Não foi possivel solicitar atualização cadastral, tente novamente.', 'error');
    } finally {
        loading.value = false
        form.accept_term = false
    }
}

const getCitiesOnMega = async () => {

    try {
        loadingUfs.value = true
        const response = await axios.get('/mega/cities');

        if (response.data) {
            states.value = getUF(response.data.message);
            allCities.value = response.data.message
            await getClientOnMega();
        }

    } catch (error) {
        console.log(error)
        showToast('Erro ao buscar dados, tente novamente', 'error');
    } finally {
        //   
    }
}

const getClientOnMega = async () => {
    try {
        loadingUfs.value = true;
        const response = await axios.get('/mega/client');
        if (response.data) {
            updateForm(response.data.message);
            filterCities()
            loadChoices()
            loadingUfs.value = false
            loadingCities.value = false
        }

    } catch (error) {
        console.error(error);
        showToast('Erro ao buscar dados, tente novamente', 'error');
    } finally {
        //aplicar mascaras
        maska.phone = ['(##) ####-####', '(##) # ####-####', '## ### #### #### ###']
        maska.postal_code = '#####-###'
    }
}

const changePassword = async () => {
    try {
        const response = await axios.post('/clients-ws/change-first-password', pass);
        if (response.data) {
            visible.value = false
            showToast('Senha alterada com sucesso.', 'success');
        }

    } catch (error) {
        console.error(error);
        showToast('Erro ao atualizar a senha, tente novamente', 'error');
    }
}

const filterCities = () => {
    if (form.state) {
        let cidades = allCities.value
        cities.value = cidades.filter(cidade => cidade.uf_sigla === form.state);
    }
    setTimeout(() => {
        addEvent()
    }, 1000);

}

const addEvent = () => {
    //------
    // @TODO
    //verificar erro updateBefore

    // if (document.getElementById("choices-cities")) {
    //     var city_element = document.getElementById("choices-cities");
    //     new Choices(city_element, {
    //         searchEnabled: true,
    //     }).setChoiceByValue(form.city);
    // }
    //------
    if (document.getElementById("choices-state")) {
        var state_element = document.getElementById("choices-state");
        new Choices(state_element, {
            searchEnabled: true,
            itemSelectText: '',
            searchPlaceholderValue: 'Pesquisar'
        }).setChoiceByValue(form.state);
    }
    const element = new Choices(document.getElementById('choices-state'));

    element.passedElement.element.addEventListener(
        'change',
        function () {
            filterCities()
        },
        false,
    );


}
const updateForm = (data) => {
    form.name = data.name
    form.email = data.email
    form.phone = data.phone
    form.marital_status = data.marital_status
    form.gender = data.gender
    form.state = data.state
    form.city = data.city
    form.municipality_code = parseInt(data.municipality_code)
    form.address = data.address
    form.address_detail = data.address_detail
    form.number = data.number
    form.neighborhood = data.neighborhood
    form.postal_code = data.postal_code

    console.log(form);
}

const getUF = (data) => {
    const uniqueUfSiglas = {};
    data.forEach(item => {
        if (!uniqueUfSiglas[item.uf_sigla]) {
            uniqueUfSiglas[item.uf_sigla] = true;
        }
    });
    return Object.keys(uniqueUfSiglas);
};

const loadChoices = () => {
    if (document.getElementById("choices-marital-status")) {
        var marital_status_element = document.getElementById("choices-marital-status");
        new Choices(marital_status_element, {
            searchEnabled: false,
            itemSelectText: '',
        }).setChoiceByValue(form.marital_status);
    }
    if (document.getElementById("choices-gender")) {
        var gender_element = document.getElementById("choices-gender");
        new Choices(gender_element, {
            searchEnabled: false,
            itemSelectText: '',
        }).setChoiceByValue(form.gender);
    }

}

const validateCPFOrCNPJ = () => {
    const cleanedInput = cpfCnpj.replace(/\D/g, '');
    const length = cleanedInput.length;

    let type;
    if (length === 11) {
        type = 'CPF';
    } else if (length === 14) {
        type = 'CNPJ';
    } else {
        type = 'Inválido';
    }

    return type
}

onMounted(async () => {
    await getCitiesOnMega();
});





</script>

<style>
.p-confirm-dialog-accept {
    color: white !important;
    background: #4F097B !important;
    border-radius: 50px !important;
}

.p-confirm-dialog-reject {
    border-radius: 50px !important;
}

.blur-effect {
    filter: blur(3px);
}

.waiting-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 30px;
    z-index: 1;
    font-weight: 400;
}
</style>